// Basic
const color = 'color';
const fontFamily = 'font-family';
const backgroundColor = 'background-color';
// Typography
const text = `text ${color} ${fontFamily}`;
const textDanger = `text-danger ${text}`;
const heading = `heading ${text}`;
const heading1 = `heading-1 ${heading}`;
const heading2 = `heading-2 ${heading}`;
const heading3 = `heading-3 ${heading}`;
const heading4 = `heading-4 ${heading}`;
const heading5 = `heading-5 ${heading}`;
// Button
const button = `button ${text}`;
const buttonPrimary = `button-primary ${button}`;
const buttonSecondary = `button-secondary ${button}`;
const buttonLink = `button-link ${button}`;
const buttonLoading = `button-loading`;
const buttonDisabled = `button-disabled ${button}`;
// Input
const label = `label ${text}`;
const input = `input ${text} ${backgroundColor}`;
const inputGroup = `input-group ${input}`;
const inputInvalid = `input-invalid ${input}`;
const inputDisabled = `input-disabled ${input}`;
const inputFocused = `input-focused ${input}`;
const inputInvalidAndFocused = `input-invalid-and-focused ${input}`;
const inputRadio = `input-radio`;
const inputRadioFocused = `input-radio-focused ${inputRadio}`;
const inputRadioChecked = `input-radio-checked ${inputRadio}`;
const inputRadioCheckedFocused = `input-radio-checked-focused ${inputRadio}`;
const inputRadioInvalid = `input-radio-invalid ${inputRadio}`;
const inputCheckbox = `input-checkbox ${backgroundColor}`;
const inputCheckboxInvalid = `input-checkbox-invalid ${inputCheckbox}`;
const inputCheckboxFocused = `input-checkbox-focused ${inputCheckbox}`;
const inputCheckboxChecked = `input-checkbox-checked ${inputCheckbox}`;
const inputCheckboxCheckedFocused = `input-checkbox-checked-focused ${inputCheckbox}`;
// Alert
const alert = `alert ${text}`;
const alertDanger = `alert-danger ${alert}`;
// Tooltip
const tooltip = `tooltip ${text}`;
const tooltipIcon = `tooltip-icon ${text}`;
const tooltipInner = `tooltip-inner ${text}`;
// Card
const card = `card ${text} ${backgroundColor}`;
// Table
const table = `table ${text} ${backgroundColor}`;
const tableCell = `table-cell ${text} ${backgroundColor}`;
const tableHeadCell = `table-head-cell ${tableCell} ${text} ${backgroundColor}`;
const tableCellEven = `table-cell-even ${tableCell} ${text} ${backgroundColor}`;
const tableCellOdd = `table-cell-odd ${tableCell} ${text} ${backgroundColor}`;
const getAlternateTableCellPart = (index) => index % 2 ? tableCellEven : tableCellOdd;
const tableEmpty = `table-empty ${text} ${backgroundColor}`;
const tableError = `table-error ${text} ${backgroundColor}`;
// Loading spinner
const loadingSpinner = `loading-spinner`;
// Badge
const badge = `badge ${fontFamily}`;
const badgePrimary = `${badge} badge-primary`;
const badgeSecondary = `${badge} badge-secondary`;
const badgeSuccess = `${badge} badge-success`;
const badgeDanger = `${badge} badge-danger`;
const badgeWarning = `${badge} badge-warning`;
const badgeInfo = `${badge} badge-info`;
const badgeLight = `${badge} badge-light`;
const badgeDark = `${badge} badge-dark`;
// Dropdown-menu
const dropdownMenu = `dropdown-menu ${text}`;
// Radio List Item
const radioListItem = `radio-list-item ${text}`;
// Skeleton
const skeleton = `skeleton`;
// Component specific
// This allows specific sections of a component to be hidden, for example
// ::part(billing-form) { display: none; }
const billingForm = `billing-form`;
const checkoutSummary = `checkout-summary`;
// Filters
const filterMenu = `filter-menu`;
const paymentsListFilterParam = `payments-list-filter-param`;
const paymentIdPaymentsListFilterParam = `${paymentsListFilterParam} payment-id-payments-list-filter-param`;
const terminalIdPaymentsListFilterParam = `${paymentsListFilterParam} terminal-id-payments-list-filter-param`;
const paymentStatusPaymentsListFilterParam = `${paymentsListFilterParam} payment-status-payments-list-filter-param`;
const createdAfterPaymentsListFilterParam = `${paymentsListFilterParam} created-after-payments-list-filter-param`;
const createdBeforePaymentsListFilterParam = `${paymentsListFilterParam} created-before-payments-list-filter-param`;

export { dropdownMenu as $, badgeSecondary as A, badgeSuccess as B, badgeDanger as C, badgeWarning as D, badgeInfo as E, badgeLight as F, badgeDark as G, alertDanger as H, inputCheckboxInvalid as I, inputCheckboxCheckedFocused as J, inputCheckboxFocused as K, inputCheckboxChecked as L, inputCheckbox as M, inputGroup as N, inputRadioInvalid as O, inputRadioCheckedFocused as P, inputRadioChecked as Q, inputRadioFocused as R, inputRadio as S, heading5 as T, heading3 as U, billingForm as V, buttonLoading as W, buttonPrimary as X, buttonSecondary as Y, checkoutSummary as Z, radioListItem as _, heading1 as a, heading4 as a0, filterMenu as a1, paymentIdPaymentsListFilterParam as a2, terminalIdPaymentsListFilterParam as a3, paymentStatusPaymentsListFilterParam as a4, createdAfterPaymentsListFilterParam as a5, createdBeforePaymentsListFilterParam as a6, inputInvalid as b, inputDisabled as c, inputFocused as d, tooltipIcon as e, tooltip as f, tooltipInner as g, heading2 as h, input as i, textDanger as j, inputInvalidAndFocused as k, label as l, card as m, table as n, tableHeadCell as o, tableCell as p, getAlternateTableCellPart as q, tableEmpty as r, skeleton as s, text as t, tableError as u, buttonLink as v, buttonDisabled as w, loadingSpinner as x, badge as y, badgePrimary as z };
